export default "__VITE_ASSET__DeHVaXch__"